module.exports = __webpack_public_path__ + "static/media/company_open.351ddfc2.png";